<template lang="html">
    <div>
    <top-progress ref="topProgress" :color="'#95d243'"></top-progress>
    <div class="panel panel-default client-pacing-panel" v-show="!loadingDetails">
        <div class="panel-body">
            <div class="panel-title" >
                Daily Spend &amp; Conversions
            </div>
            <daily-client-metrics-line-chart></daily-client-metrics-line-chart>
        </div>
    </div>
    <div class="panel panel-default client-pacing-panel" v-show="!loadingDetails">
        <div class="panel-body" :class="pacingClass(totalSpend,budget,'Monthly')">
            <div class="panel-title" >
                Monthly
            </div>
            <!-- <div style="overflow-x:auto;"> -->
                <table class="table client-pacing has-mobile-cards">
                    <thead>
                        <tr>
                            <th>Vendor</th>
                            <th>Spend</th>
                            <th>Budget</th>
                            <th>Pacing</th>
                            <th>Projected</th>
                            <th>Leftover</th>
                            <th>Leftover Per Day</th>
                            <th>Yesterday's Spend</th>
                            <th>Difference</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="mobile-hide">Total</td>
                            <td data-label="Spend">{{ totalSpend | currency }}</td>
                            <td data-label="Budget">{{ budget | currency }}</td>
                            <td data-label="Pacing">
                                {{ getCurrentPacing(totalSpend,budget) }}
                            </td>
                            <td data-label="Projected">
                                {{ getCurrentProjection(totalSpend,weekends) | currency }}
                            </td>
                            <td data-label="Leftover">
                                {{ getLeftover(totalSpend,budget,weekends) | currency }}
                            </td>
                            <td data-label="Leftover Per Day">
                                {{ getLeftoverPerDay(budget,totalSpend,weekends) | currency }}
                            </td>
                            <td data-label="Yesterday">
                                {{ yesterdaySpend | currency }}
                            </td>
                            <td data-label="Difference">
                                {{ getLeftoverPerDay(budget,totalSpend,weekends) - yesterdaySpend | currency }}
                            </td>
                        </tr>
                        <tr v-for="vendor in activeClient.vendors">
                            <td data-label="Vendor" class="mobile-hide">
                                {{ vendor.vendor }}
                            </td>
                            <td class="mobile-bb-0" :data-label="vendor.vendor">
                                {{ vendor.spend | currency }}
                            </td>
                            <td class="mobile-hide"></td>
                            <td class="mobile-hide"></td>
                            <td class="mobile-hide"></td>
                            <td class="mobile-hide"></td>
                            <td class="mobile-hide"></td>
                            <td class="mobile-hide"></td>
                            <td class="mobile-hide"></td>
                        </tr>
                    </tbody>
                </table>
            <!-- </div> -->
        </div>
    </div>
    <div v-if="activeClient.budget_groups.length > 0" v-show="!loadingDetails">
        <div>
            <div>
                <h3 class="mt-2 m-tac">Budget Groups</h3>
            </div>
        </div>
        <hr class="mt-0-5 brdc">
    </div>
    <template v-for="budget_group in activeClient.budget_groups">
        <div class="panel panel-default client-pacing-panel" v-show="!loadingDetails">
          <div class="panel-body" :class="pacingClass(0,budget_group.budget,budget_group)">
              <div class="panel-title level ai-c">
                  <span class="flex">{{ budget_group.name }}</span>
                  <span class="fs-sm">{{ budget_group.start }} - {{ budget_group.end }}</span>
              </div>
              <!-- <div style="overflow-x:auto;"> -->
                  <table class="table client-pacing has-mobile-cards">
                      <thead>
                          <tr>
                              <th>Vendor</th>
                              <th>Spend</th>
                              <th>Budget</th>
                              <th>Pacing</th>
                              <th>Projected</th>
                              <th>Leftover</th>
                              <th>Leftover Per Day</th>
                              <th>Yesterday's Spend</th>
                              <th>Difference</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                              <td class="mobile-hide">Total</td>
                              <td data-label="Spend">
                                  {{ getTotalSpendForGroup(budget_group) | currency }}
                              </td>
                              <td data-label="Budget">
                                  {{ budget_group.budget | currency }}
                              </td>
                              <td data-label="Pacing">
                                  {{ getCurrentPacingForGroup(budget_group) }}
                              </td>
                              <td data-label="Projected">
                                  {{ getCurrentProjectionForGroup(budget_group) | currency }}
                              </td>
                              <td data-label="Leftover">
                                  {{ getLeftoverForGroup(budget_group) | currency }}
                              </td>
                              <td data-label="Leftover Per Day">
                                  {{ getLeftoverPerDayForGroup(budget_group) | currency }}
                              </td>
                              <td data-label="Yesterday">
                                  {{ getYesterdaySpendForBudgetGroup(budget_group.name) | currency }}
                              </td>
                              <td data-label="Difference">
                                  {{ getLeftoverPerDayForGroup(budget_group) - getYesterdaySpendForBudgetGroup(budget_group.name) | currency }}
                              </td>
                          </tr>
                          <tr v-for="row in budget_group.metrics" v-if="row.vendor !== 'Total'">
                              <td data-label="Vendor" class="mobile-hide">
                                  {{ row.vendor }}
                              </td>
                              <td class="mobile-bb-0" :data-label="row.vendor">
                                  {{ row.spend | currency }}
                              </td>
                              <td class="mobile-hide"></td>
                              <td class="mobile-hide" ></td>
                              <td class="mobile-hide" ></td>
                              <td class="mobile-hide" ></td>
                              <td class="mobile-hide" ></td>
                              <td class="mobile-hide" ></td>
                              <td class="mobile-hide" ></td>
                          </tr>
                      </tbody>
                  </table>
              <!-- </div> -->
          </div>
        </div>
      </template>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import topProgress from 'vue-top-progress'
import DailyClientMetricsLineChart from './../charts/DailyClientMetricsLineChart.vue';

var datesAndPacing = require('./mixins/datesAndPacing');

export default {
    mixins: [datesAndPacing],

    components: {
        DailyClientMetricsLineChart,
        topProgress
    },

    data() {
        return {
            loadingDetails: true,
            budget: '',
            totalSpend: '',
            weekends: '',
            start: '',
            end: '',
            yesterdaySpend: ''
        }
    },

    computed: {
        ...mapGetters('pacing',{
            'activeClient': 'activeClient',
            'isAdmin': 'isAdmin',
        })
    },

    created() {
        let self = this;

        Bus.$on('load-client-details', this.load);

        Bus.$on('hide-client-details', function() {
            self.loadingDetails = true;
        });

        Bus.$on('chart-is-ready', function() {
            self.$refs.topProgress.done();
            self.loadingDetails = false;
        });
    },

    mounted() {
        this.setDateHelpers();
    },

    methods: {
        load(client) {
            this.loadingDetails = true;
            this.getPacingForClient(client)
        },

        getPacingForClient(client) {
            this.$refs.topProgress.start();
            this.$store.dispatch('pacing/getPacingForClient', {
                    client: client
                }).then(() => {
                    this.budget = this.activeClient.budget;
                    this.totalSpend = this.activeClient.total.spend;
                    this.weekends = this.activeClient.total.exclude_weekends;
                    this.start = this.activeClient.total.start;
                    this.end = this.activeClient.total.end;
                    this.yesterdaySpend = this.activeClient.yesterdaySpend;
                    Bus.$emit('load-daily-client-metrics-chart', this.activeClient.slug);
                })
                .catch((response) => {
                    Bus.$emit('show-error-alert', response.data.message);
                })
        },

        getTotalSpendForGroup(group) {
            return group.metrics.filter(row => row.vendor === 'Total')[0].spend;
        },

        getCurrentPacingForGroup(group) {
            let spend = this.getTotalSpendForGroup(group);
            let budget = group.budget;
            return this.getCurrentPacing(spend, budget);
        },

        getCurrentProjectionForGroup(group) {
            let spend = this.getTotalSpendForGroup(group);
            // console.log(`${group.name} - ${spend}`);
            return this.getCurrentProjectionForCustomRange(spend, group.start, group.end, group.exclude_weekends);
        },

        getLeftoverForGroup(group) {
            let spend = this.getTotalSpendForGroup(group);
            return this.getLeftoverForCustomRange(group.budget, spend, group.start, group.end, group.exclude_weekends);
        },

        getLeftoverPerDayForGroup(group) {
            let spend = this.getTotalSpendForGroup(group);
            return this.getLeftoverPerDayForCustomRange(group.budget, spend,  group.start, group.end, group.exclude_weekends);
        },

        getYesterdaySpendForBudgetGroup(group) {
            let idx = this.activeClient.budget_groups_yestetday.findIndex(g => {
                return g.name === group;
            });
            return this.activeClient.budget_groups_yestetday[idx].spend;
        },

        pacingClass(spend, budget, group) {
           let projection = group === 'Monthly' ? this.getCurrentProjection(spend,this.weekends) : this.getCurrentProjectionForGroup(group);
           if (projection > budget * 1.05) {
               return 'danger';
           } else if (projection > budget * 1 || projection < budget * .9) {
               return 'warning';
           }
           return 'success';
       },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/pacing/ClientPacingDetails.vue